import { createSlice } from "@reduxjs/toolkit";
import { checkUrlBotTg, ENUM_BALANCE_TYPE, ENUM_MADE_ON, ENUM_MODE_GAME } from "./enums";
import { getLang, getParamFromUrl, setCookie } from "../utils/utils";
import i18n from "../i18n";

const fillNoEmpty = (state, name, value) => {
  if (value === undefined) return;
  if (name === "langList") {
    state.langList = value.split(",");
    return;
  }
  if (name === "langDefault") return;

  state[name] = value;
};

export const getSession = () =>
  getParamFromUrl("sessionId") || document.cookie.match(/_GCS_SID_=(\w+)/)?.pop() || "";

// - основная информация стора о сайте
const commonSlice = createSlice({
  name: "common",
  initialState: {
    title: "",
    botTheme: getParamFromUrl("bot_theme") ?? "",
    sessionId: getSession(),
    lang: getLang(),
    modeGame: null,
    hardModeGame: null,
    langList: ["ru", "en"],
    casinoName: "",
    logoUrl: "",
    channelUrl: "",
    supportChat: "",
    supportEmail: "",
    botName: "",
    isTgBot: checkUrlBotTg(),
    isDemoMode: false,
    telegramWidget: false,
    banners: [],
    langLink: {},
    currencyDefault: "",
    currencies: {
      RUB: { decimal: 0, type: ENUM_BALANCE_TYPE.fiat },
      EUR: { decimal: 2, type: ENUM_BALANCE_TYPE.fiat },
      USDT: { decimal: 2, type: ENUM_BALANCE_TYPE.crypto }
    },
    htmlHead: "",
    logoColor: "",
    buttonColor: "",
    headerColor: "",
    bkgColor: "",
    reviewUrl: "",
    htmlEndBody: "",
    images: {
      main: { desktop: "", mobile: "" },
      menu: { desktop: "", mobile: "" },
      login: { desktop: "", mobile: "" },
      signup: { desktop: "", mobile: "" }
    },
    liveChatData: {},
    winnings: { changed: "", list: [] },
    saveSiteBeforeGame: { url: "/", topScroll: 0 },
    madeOn: checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site,
    tgRegEnabled: true,
    emailRegEnabled: true,
    emailVerifyRequire: false,
    mgrPayment: {}
  },
  reducers: {
    setModeGame(state, newAction) {
      state.modeGame = newAction.payload;
      state.isDemoMode = newAction.payload === ENUM_MODE_GAME.demo;
    },
    setHardModeGame(state, newAction) {
      state.hardModeGame = newAction.payload;
      state.modeGame = newAction.payload;
      state.isDemoMode = newAction.payload === ENUM_MODE_GAME.demo;
    },
    setSessionId(state, newAction) {
      const cookie = newAction.payload;
      state.sessionId = cookie;
    },
    setCasinoField(state, newAction) {
      const fields = newAction.payload;

      Object.keys(fields).map((el) => {
        fillNoEmpty(state, el, fields[el]);
      });
    },
    setLang(state, newAction) {
      const value = newAction.payload;
      state.lang = value;
      setCookie("language", value);
      i18n.changeLanguage(value);
    },
    setSaveSiteBeforeGame(state, newAction) {
      state.saveSiteBeforeGame = newAction.payload;
    },
    setBanners(state, newAction) {
      state.banners = newAction.payload;
    },
    setCurrencies(state, newAction) {
      state.currencies = newAction.payload;
    }
  }
});

export default commonSlice.reducer;

export const {
  setModeGame,
  setHardModeGame,
  setSessionId,
  setCasinoField,
  setCurrencies,
  setSaveSiteBeforeGame,
  setLang,
  setBanners
} = commonSlice.actions;
